export default {
    _bpreplaybold: 'bpreplaybold',
}